import { onMounted, onUnmounted, ref } from 'vue';

export function useReducedMotion() {
  const mediaQuery =
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

  const isReducedMotion = ref(mediaQuery ? mediaQuery.matches : false);

  const updateState = e => {
    isReducedMotion.value = e.matches;
  };

  onMounted(() => {
    if (mediaQuery) {
      mediaQuery.addEventListener('change', updateState);
    }
  });

  onUnmounted(() => {
    if (mediaQuery) {
      mediaQuery.removeEventListener('change', updateState);
    }
  });

  return { isReducedMotion };
}
